<style lang="scss" scoped>
.bottom-bar {
  padding-right: 0.24rem;
}
.cart-bar {
  display: flex;

  height: 1rem;

  background-color: #fff;

  justify-content: flex-end;

  line-height: 1rem;

  .cart-total-price {
    float: right;

    margin-right: 0.2rem;
    padding-top: 0.2rem;

    font-size: 0.24rem;
    line-height: 0.35rem;
    text-align: right;

    color: #666;

    .num {
      font-size: 0.28rem;
      color: #ff6f14;
    }
    .desc {
      transform: scale(0.83, 0.83);
      transform-origin: right top;
    }
  }
  .btn-goto-cart {
    width: 1.8rem;
    height: 0.72rem;

    background-image: linear-gradient(to left, #f03100, #ff572b);
    border-radius: 0.36rem;

    @include flex-row-center;
    @include text(0.28rem, #fff);
  }
}
</style>

<template>
  <div class="bottom-bar">
    <div class="cart-bar cf">
      <div v-show="totalAmount != 0" class="cart-total-price">
        <p class="price">
          合计：
          <span class="num">¥{{ numToFixed(totalAmount) }}</span>
        </p>
        <p class="desc">{{ packageDesc }}</p>
      </div>
      <div class="btn-goto-cart" @click="goCart">去购物车</div>
    </div>
  </div>
</template>

<script>
import { numToFixed } from '@/utils/utils'
import { cart } from '@/utils/cart/index'
export default {
  data() {
    return {
      totalAmount: 0,
      packageDesc: ''
    }
  },
  created() {
    this.totalAmount = cart.totalAmount
    this.cartListenerId = cart.onChange(() => {
      this.totalAmount = cart.totalAmount
      this.packageDesc = cart.packageDesc
    })
  },
  beforeDestroy() {
    cart.removeChangeHandler(this.cartListenerId)
  },
  methods: {
    numToFixed,
    goCart() {
      const popId = this.$route.query.pop_id
      this.$track(this.$trackMap.pop.popGoShoppingCart, {
        pop_id: Number(popId)
      })
      this.$nativeRedirect(this.$nativeRoutes.cart)
    }
  }
}
</script>
